// QuietMenu.tsx — ONE control where the fleet has two circles (Focus had three).
//
// 🔴 IDENTITY (2026-08-30): "wordmark-left + circular controls right" is one of the four banned
// fleet fingerprints. Focus lost its "Oriora Focus" wordmark row entirely (the commitment line is
// the header now), and backup + settings + account collapse here into a single control drawn in
// this app's assigned material: ONE uninterrupted surface, so the control has no fill, no border
// and no radius — chrome that recedes rather than another shape stuck on top.
//
// The shared BackupMenu / AccountMenu are rendered UNCHANGED inside — the account-deletion flow
// the store gate depends on lives inside AccountMenu and must not be reimplemented here.

import { useState, type ReactNode } from "react";

export function QuietMenu({ backup, account, onSettings }: { backup: ReactNode; account: ReactNode; onSettings: () => void }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        className="sfl-menu-btn"
        aria-label="Settings, backup and account"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="3.2" stroke="currentColor" strokeWidth="1.6" />
          <path d="M12 2.5v2.2M12 19.3v2.2M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6"
                stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 40 }} />
          <div className="sfl-menu-panel">
            <button className="sfl-menu-row" style={{ width: "100%", background: "none", border: 0, textAlign: "left", cursor: "pointer" }}
                    onClick={() => { setOpen(false); onSettings(); }}>
              Settings
            </button>
            <div className="sfl-menu-rule" />
            <div className="sfl-menu-row">{backup}<span>Back up &amp; restore</span></div>
            <div className="sfl-menu-rule" />
            <div className="sfl-menu-row">{account}<span>Account</span></div>
          </div>
        </>
      )}
    </div>
  );
}
